import { render, staticRenderFns } from "./WhatsappRodapeEdit.vue?vue&type=template&id=c5a8afc0"
import script from "./WhatsappRodapeEdit.vue?vue&type=script&lang=js"
export * from "./WhatsappRodapeEdit.vue?vue&type=script&lang=js"
import style0 from "./WhatsappRodapeEdit.vue?vue&type=style&index=0&id=c5a8afc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports